export default __webpack_public_path__ + "static/media/mad-ape-011.b72e55a1.svg";